<template>
  <div id="management-layout">
    <div class="nav" :style="{ height: `${isAndroidWeb && isUnderWechat ? 88 : isAndroidWeb || isUnderWechat ? 47 : 0}px` }">
      <div class="nav-fixed">
        <!-- 安卓设备展示 -->
        <div v-if="isAndroidWeb" class="android-download-tip">
          <div class="title">
            <i class="iconfont lc-ico-android-app"></i>
            {{ $t('common.android_download_tip.sp_android_version') }}
          </div>
          <a :href="spHomeUrl + '/apps/stores'">
            {{ $t('common.android_download_tip.download_btn') }}
            <i class="el-icon-download"></i>
          </a>
        </div>

        <!-- 公众号下展示 -->
        <div v-if="isUnderWechat" class="mobile-nav">
          <div class="clearfix mobile-nav-fixed">
            <!-- 主页 -->
            <a :href="`${spHomeUrl}${spUrlPathName}?is_from_pc=true`" class="mobile-nav-fixed-right p-r-10"
              ><i class="iconfont lc-ico-return-home m-r-3" style="font-size:15px"></i>返回移动端首页</a
            >

            <!-- 菜单 -->
            <i class="el-icon-menu m-t-12 p-l-10 mobile-nav-fixed-left" style="font-size:18px" @click="handleMenuDisplay"></i>

            <!-- 标题 -->
            <span class="mobile-nav-title">ECMP平台端</span>
          </div>
        </div>
      </div>
    </div>

    <div id="wrapper">
      <!-- 左侧菜单 -->
      <div v-show="!isMenuCollapse" id="menu" class="main-page-left">
        <!-- 菜单：底部预留70是为了不被收起/展开按钮遮挡 -->
        <system-menu style="margin-bottom: 70px" @display-all-functions="allFunctionsVisible = true" />

        <!-- 收起/展开 -->
        <!--
        <div v-show="currentAdmin.admin_type !== 'group_admin'" class="control-menu">
          <div v-if="isMenuCollapse" class="collapsed" @click="showMenu">
            <img src="/images/menu/icon_right.svg" width="14" />
          </div>
          <div v-else class="expanded" @click="hideMenu"><img src="/images/menu/icon_left.svg" width="14" /> 收起</div>
        </div>
        -->
        <div class="all-functions-button-control">
          <a href="javascript:void(0)" @click="allFunctionsVisible = true">
            <i class="el-icon- lc-ico-menu-round lc-primary-color"></i>
            <span slot="title" class="all-functions-menu-item--text lc-primary-color">全部功能</span>
          </a>
          <!-- <i class="el-icon- lc-ico-menu-round lc-primary-color"></i>
          <span slot="title" class="all-functions-menu-item--text lc-primary-color">全部功能</span> -->
        </div>
      </div>

      <!-- 主体内容部分 -->
      <div id="content" class="main-page-right" :style="mainPageStyle">
        <router-view ref="workspace" />
      </div>
    </div>

    <div id="pop-box-hint">
      <transition name="slide-fade">
        <p v-show="loading" class="loading lc-primary-color">
          <i class="el-icon-loading"></i>
          {{ $t('common.loading_text') }}
        </p>
      </transition>
    </div>

    <!-- 删除弹窗 -->
    <lc-delete-confirm-dialog ref="deleteConfirmDialogRef"></lc-delete-confirm-dialog>
    <!-- /.modal -->

    <!-- 全部功能 -->
    <all-functions v-model="allFunctionsVisible" />
  </div>
</template>

<script>
/*global app, ASSETS_VERSION */

import Vue from 'vue'
import Menu from './Menu.vue'
import ActionCable from 'actioncable'
import { ExportDoneEvent, ExportTimestampKey, ExportExportingEvent } from '@/constants/global_variables'
import notice from '@/utils/notices.js'
import Identification from '@/mixins/identification'
import store from '@/stores'
import spApi from '@/api/service_provider'
import urlHelper from '@/helpers/url_helper'
import LcDeleteConfirmDialog from '@/components/dialogs/LcDeleteConfirmDialog'
import nativeMsgUtil from '@/utils/native_msg_util'
import AllFunctions from '@/layouts/AllFunctions'

window.is_search_panel_float = false
window.ASSETS_VERSION = 20190909094209790

export default {
  name: 'ManagementLayout',
  components: {
    systemMenu: Menu,
    LcDeleteConfirmDialog,
    AllFunctions
  },
  mixins: [Identification],
  data() {
    return {
      displayNav: true,
      menuOffset: 0,
      // 已异步加载过的CSS
      loadedCSS: [],
      loadedJS: [],
      name: 'SaaS',
      shortcuts: [
        {
          name: 'menu.charge_station.index',
          link: '/charge_stations'
        },
        {
          name: 'menu.charger.index',
          link: '/chargers'
        },
        {
          name: 'menu.transaction.order',
          link: '/orders'
        }
      ],
      system_info: {
        system_info: '',
        service_provider_name_title: '',
        service_provider_name: '',
        system_version_title: '',
        system_version: '',
        commit_info: '',
        commit_id: '',
        close: '',
        browser_description_title: '',
        browser_description: '',
        ui_version: process.env.VUE_APP_VERSION,
        ui_commit: '',
        ui_build_version: ''
      },
      spHomeUrl: process.env.VUE_APP_ECMP_SP_HOME,
      isUnderWechat: false,
      isAndroidWeb: false,
      allFunctionsVisible: false
    }
  },
  computed: {
    /**
     * 菜单是否收起
     *
     * @returns {boolean} 是否收起
     */
    isMenuCollapse() {
      // 直接读取 state
      return this.$store.state.menu.isCollapse
    },
    loading() {
      return this.$store.getters.loading
    },
    notice() {
      return this.$store.state.app.notice
    },
    toast() {
      return this.$store.state.app.toast
    },
    mainPageStyle() {
      // 屏幕高度减去顶部导航（如果在原生下，因为没有了顶部的导航栏，所以不需要减）
      // return this.displayNav ? 'height: calc(100vh - 50px)' : 'height: 100vh'
      return 'height: 100vh'
    },
    spUrlPathName() {
      if (localStorage.getItem('sp_url_path_name')) {
        return localStorage.getItem('sp_url_path_name')
      }
      return ''
    }
  },
  watch: {
    // 监控 currentAdmin, 当 currentAdmin 发生改变并且存在时
    currentAdmin: {
      handler(new_val, old_val) {
        if (this.currentAdmin && new_val.id != old_val.id) {
          this.listenAdminChannel(this.currentAdmin.id)
        }
      },
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.app.currentAdmin.id == null) {
      store
        .dispatch('app/fetchInfoAfterSignIn')
        .then(() => {
          next()
        })
        .catch(() => {
          Vue.prototype.$toast.error(app.$t('common.fail_to_get_data'))
        })
    }

    next()
  },
  created() {
    window.management = this
    this.initActionCable()
    this.listenSystemChannel()
    window.app.bus.$on('receivedNativeMessage', this._onReceivedNativeMessage)

    // 如果是在原生下，不展示顶部导航（原生自带导航，避免双导航），一打开就隐藏侧边菜单
    if (nativeMsgUtil.isUnderNative()) {
      this.displayNav = false
      this.hideMenu()
    } else if (nativeMsgUtil.isUnderMobile()) {
      this.isUnderWechat = true // 启动手机端
      this.displayNav = false
      this.hideMenu()
      if (nativeMsgUtil.isAndroid()) {
        // 在安卓移动端显示下载提示，原生不显示
        this.isAndroidWeb = true
      }
    }
  },
  beforeDestroy() {
    window.app.bus.$off('receivedNativeMessage', this._onReceivedNativeMessage)
  },
  mounted() {
    let code = this.$route.query.service_provider_code
    let params = {}
    if (code) {
      params = {
        domain: urlHelper.getHostname(),
        code: code
      }
    } else {
      params = {
        domain: urlHelper.getHostname()
      }
    }
    spApi.getDetailByDomain(params).then(response => {
      localStorage.setItem('theme', response.data.theme)
      $('link[rel="icon"]').attr('href', response.data.favicon_ico || '/images/logo.png')
      $('title').text(response.data.title || this.$t('sign_in.title'))
    })

    if (this.currentAdmin) {
      this.listenAdminChannel(this.currentAdmin.id)
    }
  },
  methods: {
    /**
     * 收到消息
     *
     * @param {object} message 消息。格式 { command: '', data: {} }
     */
    _onReceivedNativeMessage(message) {
      let data = nativeMsgUtil.getMenuExpanded(message)
      if (!this.isEmptyObject(data)) {
        // 控制菜单展开或者关闭
        data.expanded ? this.showMenu() : this.hideMenu()
      }
    },
    openServerInfo() {},
    workspace() {
      return this.$refs.workspace
    },
    initActionCable() {
      Vue.prototype.$cable = ActionCable.createConsumer(process.env.VUE_APP_WS)
      Vue.prototype.$cableObject = {}
    },
    listenSystemChannel() {
      let self = this
      this.$cableObject.system = this.$cable.subscriptions.create(
        { channel: 'SystemChannel' },
        {
          connected() {
            self.$store.dispatch('app/toggleNetwork', { health: true })
            console.log('system cable connected')
            // Logger.info('system cable connected')
          },
          disconnected() {
            self.$store.dispatch('app/toggleNetwork', { health: false })
            console.log('system cable disconnected')
            // Logger.info('system cable disconnected')
          },
          received(data) {
            if (data.type === 'Alarm') {
              if (data.action === 'add') {
                self.$store.dispatch('app/updateUnresolvedAlarmCount', self.$store.state.app.unresolvedAlarmCount + 1)
              } else if (data.action === 'subtract') {
                self.$store.dispatch('app/updateUnresolvedAlarmCount', self.$store.state.app.unresolvedAlarmCount - 1)
              }
              self.$store.dispatch('app/updateCanQueryAlarms', true)
            }
          },
          update(msg) {
            this.perform('update', { data: msg })
          }
        }
      )
    },
    listenAdminChannel(admin_id) {
      if (admin_id == undefined) return

      if (this.$cableObject.admin != undefined) {
        // 清空旧订阅
        this.$cableObject.admin.unsubscribe()
        // unsubscribe 之后需要延迟 1 秒，否则无法订阅成功
        setTimeout(() => {
          this.createAdminSubscription(admin_id)
        }, 1000)
      } else {
        this.createAdminSubscription(admin_id)
      }
    },
    createAdminSubscription(admin_id) {
      let self = this
      this.$cableObject.admin = this.$cable.subscriptions.create(
        {
          channel: 'ObjectListenChannel',
          object_type: 'Admin',
          object_id: admin_id
        },
        {
          connected() {
            console.log('Connected admin ' + admin_id + ' on ObjectListenChannel')
          },
          disconnected: function() {
            console.log('Disconnected admin ' + admin_id + ' on ObjectListenChannel')
          },
          received(data) {
            console.log('[Admin channel]', data)
            var msg = data.message
            let params = {
              title: msg.title,
              message: msg.content + ` <a href="${msg.uri}" target="_blank">点击下载</a>`, // 需要解决请求过于频繁的问题
              timeout: 30 * 60 * 1000,
              closeButtonText: '知道了'
            }

            // download_type: orders/charge_stations
            if (msg.message_type == 'download') {
              // 收到报表导出完成，可以下载的信息
              let download_type = msg.download_type

              // 下载完成
              self.$emit(ExportDoneEvent, download_type)

              let export_timestamp_key = sessionStorage.getItem(download_type + ExportTimestampKey)
              // console.log(`当前标签页导出文件下载: 下载时生成的标识 ${export_timestamp_key}, 后台返回报表标识: ${msg.export_timestamp_key}`)
              if (msg.export_timestamp_key == export_timestamp_key) {
                // 如果 exportTimestampKey 与收到的是匹配，说明是我导出的订单，需要下载
                // 因为 PDF 类型跳转会覆盖原页面，所以采用 open
                if (msg.content_type == 'application/pdf') {
                  window.open(msg.uri)
                } else {
                  window.location.href = msg.uri
                }
              }
            } else if (msg.message_type === 'download_fail') {
              // 下载失败
              self.$emit(ExportDoneEvent, msg.report_type)
            } else if (msg.message_type == 'exporting_file') {
              // 导出中
              let downloadType = msg.download_type // 如 orders/chargers

              // 通知按钮
              self.$emit(ExportExportingEvent, {
                report: downloadType,
                percentage: msg.percentage
              })
              return // 不需要弹窗通知
            } else {
              params = $.extend(params, {
                detailButtonText: '查看详情',
                url: msg.uri
              })
            }
            notice(msg.message_level, params)
          }
        }
      )
    },
    // show menu again
    showMenu() {
      // 更新菜单收起的信息
      this.$store.dispatch('menu/updateIsCollapse', false)
    },
    // collapse menu and expand content area
    hideMenu() {
      // 更新菜单收起的信息
      this.$store.dispatch('menu/updateIsCollapse', true)
    },
    loadScript(url) {
      var target_url = url + '?version=' + ASSETS_VERSION
      $.getScript(target_url).fail(function(jqxhr, settings, exception) {
        // 打印异步加载JS的异常信息用于帮助调试
        /* eslint-disable */ /* no-console */
        console.log(target_url)
        console.log(exception)
        /* eslint-enable */
      })
    },
    loadStyle(url) {
      var target_url = url + '?version=' + ASSETS_VERSION
      // 检测是否已加载过
      if ($.inArray(target_url, this.loadedCSS) == -1) {
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', target_url))
        this.loadedCSS.push(target_url)
      }
    },
    /**
     * 批量按顺序加载 js使用方案 eval(loadScriptQueue(['file.js', 'file2.js']))。后期修改，调用不需要使用 eval
     *
     * @param {Array<string>} array JS 文件
     * @param {Function} successCallback 回调方法
     * @param {boolean} reload 是否重新加载
     * @returns {string} js 脚本
     */
    loadScriptQueue(array, successCallback, reload) {
      var self = this
      var str = ''
      var flag = false
      var outArrayNumber = 0
      array.forEach(function(item, index) {
        if (reload) {
          str += '$.getScript("' + item + '", function() {'
          if (successCallback && array.length - 1 == index) {
            str += successCallback
          }
        } else {
          if ($.inArray(item, self.loadedJS) == -1) {
            flag = true
            outArrayNumber += 1
            self.loadedJS.push(item)
            str += '$.getScript("' + item + '", function() {'
            if (successCallback && array.length - 1 == index) {
              str += successCallback
            }
          }
        }
      })
      if (reload) {
        for (let i = 0; i < array.length; i++) {
          str += '})'
        }
      } else {
        for (let i = 0; i < outArrayNumber && flag; i++) {
          str += '})'
        }
      }

      //当不需要加载js文件时
      if (str == '') {
        str += successCallback
      }
      return str
    },
    /**
     * 关闭提示信息
     */
    handleCloseToast() {
      this.$toast.close()
    },
    handleMenuDisplay() {
      if (this.isMenuCollapse) {
        this.showMenu()
      } else {
        this.hideMenu()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#wrapper {
  display: flex;
  // height: calc(100vh - 48px); // 去除顶部导航
  height: 100vh;

  .main-page-left {
    background-color: #333333;
    // z-index: 100;
    min-height: 100%;
    overflow: auto;

    .control-menu {
      height: 25px;
      // text-align: center;
      position: fixed;
      height: 60px;
      background-color: #333333;
      bottom: 0px;
      color: #fff;

      .expanded,
      .collapsed {
        cursor: pointer;
        display: inline-block;
        vertical-align: -webkit-baseline-middle;
      }

      .expanded {
        padding-left: 45px;
        width: 150px;
      }
      .collapsed {
        margin-left: 25px;
      }
    }

    .all-functions-button-control {
      position: fixed;
      left: 0;
      bottom: 0px;
      background-color: #333333;
      padding: 10px 0px 25px 25px;
      font-size: 16px;
      width: 150px;

      i {
        font-size: 20px;
        margin-right: 5px;
      }

      .all-functions-menu-item--text {
        font-weight: 600;
        vertical-align: top;
        font-size: 14px;
      }
    }
    @media screen and (max-width: 600px) {
      .all-functions-button-control {
        position: absolute;
      }
    }
  }
  .main-page-right {
    overflow-y: auto;
    flex: 1;
    padding: 8px;
  }
}

.toast-btn {
  margin-left: 10px;
  cursor: pointer;
}

.row {
  height: 30px;
  line-height: 30px;
}
.nav {
  .nav-fixed {
    position: fixed;
    width: 100%;
    .android-download-tip {
      line-height: 22px;
      height: 40px;
      padding: 10px 16px;
      background: #fdf6ec;
      color: #f79300;
      display: flex;
      justify-content: space-between;
      vertical-align: middle;
      .title {
        font-size: 14px;
      }
      a {
        color: #f79300;
        font-size: 12px;
      }
    }
    .mobile-nav {
      height: 46px;
      text-align: center;
      .mobile-nav-fixed {
        line-height: 46px;
        background-color: #48c483;
        color: white;
        a {
          color: white;
        }
        .mobile-nav-fixed-left {
          position: absolute;
          left: 0;
        }
        .mobile-nav-fixed-right {
          position: absolute;
          right: 0;
        }
      }

      .mobile-nav-title {
        font-size: 14px;
      }
    }
  }
}
</style>
